export const LAYER_SYMBOL = {
  GEOLOCATION: 'GEOLOCATION',
  POWER_LINE: 'POWER_LINE'
} as const;

